import React from 'react';
import { History, Undo2 } from 'lucide-react';
import TextVersionHistory from './TextVersionHistory';
import { isPersistedUuid } from '../../utils/resourceIds';

const actionButtonClass =
  'inline-flex items-center gap-1.5 rounded-md border border-slate-200 bg-white px-2 py-1 text-xs font-medium text-forge-600 shadow-sm hover:border-forge-300 hover:bg-forge-50 hover:text-forge-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors';

function TextFieldActions({
  stackKey,
  canUndo,
  onUndo,
  resourceType,
  resourceId,
  fieldName,
  onRestoreFromHistory,
  disabled = false,
}) {
  const showHistory =
    resourceType && resourceId && fieldName && isPersistedUuid(resourceId);

  if (!canUndo && !showHistory) {
    return null;
  }

  return (
    <div className="mt-1.5 flex flex-wrap items-center gap-3">
      {canUndo && (
        <button
          type="button"
          onClick={onUndo}
          disabled={disabled}
          className={actionButtonClass}
          title="Desfazer última melhoria"
        >
          <Undo2 className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
          Desfazer
        </button>
      )}
      {showHistory && (
        <TextVersionHistory
          resourceType={resourceType}
          resourceId={resourceId}
          fieldName={fieldName}
          onRestore={onRestoreFromHistory}
          disabled={disabled}
          buttonClassName={actionButtonClass}
        />
      )}
    </div>
  );
}

export default TextFieldActions;
